__turbopack_context__.v({
  "active": "VendasModule-module__eI7Uja__active",
  "appBody": "VendasModule-module__eI7Uja__appBody",
  "appHeader": "VendasModule-module__eI7Uja__appHeader",
  "appWindow": "VendasModule-module__eI7Uja__appWindow",
  "backBtn": "VendasModule-module__eI7Uja__backBtn",
  "badge": "VendasModule-module__eI7Uja__badge",
  "barcodeInput": "VendasModule-module__eI7Uja__barcodeInput",
  "blink": "VendasModule-module__eI7Uja__blink",
  "cardIcon": "VendasModule-module__eI7Uja__cardIcon",
  "cardTop": "VendasModule-module__eI7Uja__cardTop",
  "cartEmpty": "VendasModule-module__eI7Uja__cartEmpty",
  "cartHeader": "VendasModule-module__eI7Uja__cartHeader",
  "cartItem": "VendasModule-module__eI7Uja__cartItem",
  "checkoutBody": "VendasModule-module__eI7Uja__checkoutBody",
  "checkoutHeader": "VendasModule-module__eI7Uja__checkoutHeader",
  "checkoutLabel": "VendasModule-module__eI7Uja__checkoutLabel",
  "clicked": "VendasModule-module__eI7Uja__clicked",
  "col1": "VendasModule-module__eI7Uja__col1",
  "col2": "VendasModule-module__eI7Uja__col2",
  "col3": "VendasModule-module__eI7Uja__col3",
  "cursor": "VendasModule-module__eI7Uja__cursor",
  "description": "VendasModule-module__eI7Uja__description",
  "fakeInput": "VendasModule-module__eI7Uja__fakeInput",
  "featureIcon": "VendasModule-module__eI7Uja__featureIcon",
  "featureItem": "VendasModule-module__eI7Uja__featureItem",
  "featureList": "VendasModule-module__eI7Uja__featureList",
  "finishBtn": "VendasModule-module__eI7Uja__finishBtn",
  "floatMockup": "VendasModule-module__eI7Uja__floatMockup",
  "headerSub": "VendasModule-module__eI7Uja__headerSub",
  "headerTitle": "VendasModule-module__eI7Uja__headerTitle",
  "hubHeader": "VendasModule-module__eI7Uja__hubHeader",
  "hubIcon": "VendasModule-module__eI7Uja__hubIcon",
  "hubItem": "VendasModule-module__eI7Uja__hubItem",
  "hubList": "VendasModule-module__eI7Uja__hubList",
  "hubOverlay": "VendasModule-module__eI7Uja__hubOverlay",
  "hubSub": "VendasModule-module__eI7Uja__hubSub",
  "hubTitle": "VendasModule-module__eI7Uja__hubTitle",
  "hubWindow": "VendasModule-module__eI7Uja__hubWindow",
  "itemName": "VendasModule-module__eI7Uja__itemName",
  "itemPhoto": "VendasModule-module__eI7Uja__itemPhoto",
  "itemSku": "VendasModule-module__eI7Uja__itemSku",
  "mlBadge": "VendasModule-module__eI7Uja__mlBadge",
  "mockupContainer": "VendasModule-module__eI7Uja__mockupContainer",
  "moduleWrapper": "VendasModule-module__eI7Uja__moduleWrapper",
  "orange": "VendasModule-module__eI7Uja__orange",
  "popIn": "VendasModule-module__eI7Uja__popIn",
  "posCard": "VendasModule-module__eI7Uja__posCard",
  "posLeft": "VendasModule-module__eI7Uja__posLeft",
  "posRight": "VendasModule-module__eI7Uja__posRight",
  "prodName": "VendasModule-module__eI7Uja__prodName",
  "prodSku": "VendasModule-module__eI7Uja__prodSku",
  "pulseGlow": "VendasModule-module__eI7Uja__pulseGlow",
  "searchBar": "VendasModule-module__eI7Uja__searchBar",
  "shopeeBadge": "VendasModule-module__eI7Uja__shopeeBadge",
  "spin": "VendasModule-module__eI7Uja__spin",
  "spinner": "VendasModule-module__eI7Uja__spinner",
  "stockArea": "VendasModule-module__eI7Uja__stockArea",
  "stockChange": "VendasModule-module__eI7Uja__stockChange",
  "stockNum": "VendasModule-module__eI7Uja__stockNum",
  "stockPrice": "VendasModule-module__eI7Uja__stockPrice",
  "successOverlay": "VendasModule-module__eI7Uja__successOverlay",
  "syncTag": "VendasModule-module__eI7Uja__syncTag",
  "synced": "VendasModule-module__eI7Uja__synced",
  "syncing": "VendasModule-module__eI7Uja__syncing",
  "textContent": "VendasModule-module__eI7Uja__textContent",
  "title": "VendasModule-module__eI7Uja__title",
  "totalFinal": "VendasModule-module__eI7Uja__totalFinal",
  "totalRow": "VendasModule-module__eI7Uja__totalRow",
  "totalsArea": "VendasModule-module__eI7Uja__totalsArea",
});
